import React, { useEffect, useState } from 'react';
import { Loader2, Check, X as XIcon } from 'lucide-react';

function QuestionCard({ q, i, chosen, onPick, reveal, prefix }) {
  return (
    <div className="neo-card p-3 bg-white" data-testid={`${prefix}-q-${i}`}>
      <p className="text-sm font-bold whitespace-pre-line mb-2"><span className="opacity-50 mr-1">{i + 1}.</span>{q.q}</p>
      <div className="grid gap-1.5">
        {q.options.map((o, j) => {
          const isCorrect = reveal && j === q.correct;
          const isWrong = reveal && j === chosen && j !== q.correct;
          return (
            <button key={j} disabled={reveal} onClick={() => onPick(j)} data-testid={`${prefix}-q-${i}-opt-${j}`}
              className={`text-left text-sm px-3 py-2 rounded-xl border-2 flex items-center gap-2 transition-colors ${
                isCorrect ? 'bg-[#B9FBC0] border-[#3A8A55]' : isWrong ? 'bg-[#FFD1D1] border-[#C24672]'
                  : chosen === j ? 'bg-[#FFE8A3] border-black' : 'bg-white border-black/15 hover:border-black/50'}`}>
              <span className="font-black opacity-50 w-4">{String.fromCharCode(65 + j)}</span>
              <span className="flex-1">{o}</span>
              {isCorrect && <Check className="w-4 h-4" />}
              {isWrong && <XIcon className="w-4 h-4" />}
            </button>
          );
        })}
      </div>
      {reveal && q.explanation && <p className="text-xs italic opacity-75 mt-2" data-testid={`${prefix}-q-${i}-explanation`}>💡 {q.explanation}</p>}
    </div>
  );
}

// Shared quiz body for the daily pass and extra passes.
export default function HpQuiz({ quiz, onSubmit, busy, prefix = 'hp-daily', doneText, timeUp = false }) {
  const [answers, setAnswers] = useState(quiz.answers || []);
  useEffect(() => { setAnswers(quiz.answers || []); }, [quiz.questions, quiz.answers]);
  const { questions, submitted } = quiz;
  const filled = () => questions.map((_, i) => (answers[i] === undefined || answers[i] === null ? -1 : answers[i]));
  useEffect(() => {
    if (timeUp && !submitted && !busy && questions?.length) onSubmit(filled());
  }, [timeUp]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!questions?.length) return null;
  const allAnswered = questions.every((_, i) => answers[i] !== undefined && answers[i] >= 0);

  return (
    <div className="space-y-3">
      {quiz.passage && <div className="bg-white rounded-xl p-3 text-sm whitespace-pre-line border-2 border-black/10" data-testid={`${prefix}-passage`}>{quiz.passage}</div>}
      {questions.map((q, i) => (
        <QuestionCard key={i} q={q} i={i} chosen={answers[i]} reveal={submitted} prefix={prefix}
          onPick={(j) => setAnswers((p) => { const n = [...p]; n[i] = j; return n; })} />
      ))}
      {!submitted && (
        <button onClick={() => onSubmit(filled())} disabled={(!allAnswered && !timeUp) || busy} className="neo-btn w-full py-3 bg-[#B9FBC0] font-bold disabled:opacity-50" data-testid={`${prefix}-submit`}>
          {busy ? <Loader2 className="w-4 h-4 animate-spin mx-auto" /> : 'Lämna in 🐹'}
        </button>
      )}
      {submitted && (
        <div className="text-center bg-white rounded-xl p-3" data-testid={`${prefix}-result`}>
          <div className="font-['Fredoka'] text-2xl font-bold">{quiz.score}/{questions.length} rätt</div>
          <p className="text-xs opacity-70">{doneText}</p>
        </div>
      )}
    </div>
  );
}
